// extracted by mini-css-extract-plugin
module.exports = {"banner":"RecapBanner_banner__4574w","header":"RecapBanner_header__nTN55","label":"RecapBanner_label__pfmXQ","text":"RecapBanner_text__4aBju","full":"RecapBanner_full__Ubvuq"};